import { RESPONSE_HEADER } from "../utils/enums";

export const konditionenKey = "sortenProduktKonditionen";
export const konditionenListe = "listeSortenProduktKonditionen";
export const stufenKonditionen = "listeStufenKonditionen";
export const konditionenAbsolut = "konditionAbsolut";
export const defaultKeys = [
  "defaultSoBpBuyKondition",
  "defaultSoMaBuyKondition",
  "defaultSoWlBuyKondition"
];
export const defaultBetrag = [
  "defaultSoBpBuyBetrag",
  "defaultSoMaBuyBetrag",
  "defaultSoWlBuyBetrag"
];
export const listKeys = {
  editierbar: ["soBpBuyEditierbarKz", "soMaBuyEditierbarKz", "soWlBuyEditierbarKz"],
  konditionen: ["soBpBuyKondition", "soMaBuyKondition", "soWlBuyKondition"],
  kurs: ["soBpBuyKurs", "soMaBuyKurs", "soWlBuyKurs"],
  headers: ["Verkauf Beratershop", "Mitarbeiter Konditionen", "Verkauf Kundenshop"],
  preisHeaders: ["", "", ""],
  isMaKond: [false, true, false],
};

export const testData = {
  "header": { "status": RESPONSE_HEADER.STATUS.SUCCESSFUL, "version": "2.0.0.0", "build": "b1539", "sessionId": "202207232257559715309" },
  "hashCode": "202110051140",
  "defaultSoBpBuyKondition": 1,
  "defaultSoBpSellKondition": 2,
  "defaultSoWlBuyKondition": 1,
  "sortenProduktKonditionen": {
    "listeSortenProduktKonditionen": [
      {
        "kennziffer": "11720",
        "bezeichnung": "China (Volksrep.) -Renmimbi",
        "soBpBuyEditierbarKz": "N",
        "soBpSellEditierbarKz": "N",
        "soWlBuyEditierbarKz": "N",
        "soBpBuyKurs": 5.701,
        "soBpSellKurs": 5.902,
        "soWlBuyKurs": 5.503,
        "soMaBuyKurs": 5.603,
        "soMaBuyKondition": 1.9,
        "soBpBuyKondition": 2,
        "soBpSellKondition": 3,
        "soWlBuyKondition": 5
      },
      {
        "kennziffer": "11732",
        "isoCode": "JPY",
        "bezeichnung": "Japan - Yen",
        "kurs": 127.94,
        "einheit": "1,0000",
        "innen_provision": 6,
        "kleinsteStueckelung": 1000,
        "soBpBuyEditierbarKz": "N",
        "soBpSellEditierbarKz": "N",
        "soWlBuyEditierbarKz": "N",
        "soBpBuyKurs": 127.94,
        "soBpSellKurs": 128.94,
        "soWlBuyKurs": 126.94,
        "soMaBuyKurs": 128,
        "soMaBuyKondition": 1.9,
        "soBpBuyKondition": 2,
        "soBpSellKondition": 3,
        "soWlBuyKondition": 1
      }]
  }
};

export default {
  konditionenKey,
  konditionenListe,
  stufenKonditionen,
  defaultKeys,
  defaultBetrag,
  listKeys,
  testData
};
